import { useState } from 'react';

export const useForm = (initialForm = {}) => {
    const [formState, setFormState] = useState(initialForm);
    const [elementResetFlag, setElementResetFlag] = useState(false); // para select-lists mediante su `key`

    // Formateador de números
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });

    const onInputChangeForNumber = ({ target }) => {
        const { name, value } = target;

        const cleanValue = value.replace(/,/g, '');
        const validNumber = /^-?\d*\.?\d*$/.test(cleanValue);

        if (!validNumber) return;

        if (cleanValue === '' || cleanValue === '.') {
            setFormState({
                ...formState,
                [name]: value,
                [`clean_${name}`]: parseFloat(cleanValue)
            });
            return;
        }

        let [integerPart, decimalPart] = cleanValue.split('.');
        if (decimalPart !== undefined) decimalPart = decimalPart.slice(0, 2);

        const formattedInteger = numberFormatter.format(parseFloat(integerPart || 0));
        const formattedValue = decimalPart !== undefined
            ? `${formattedInteger}.${decimalPart}`
            : formattedInteger;

        setFormState({
            ...formState,
            [name]: formattedValue,
            [`clean_${name}`]: parseFloat(cleanValue)
        });
    };

    const onInputChange = ({ target }) => {
        const { name, value } = target;
        setFormState({
            ...formState,
            [name]: value
        });
    };

    const onSelectSearchChange = (event) => {
        const { name, value } = event.target;
        setFormState({
            ...formState,
            [name]: value
        });
    };

    // ---- NUEVO: DropZone + imágenes ----
    const onDropZoneAcceptedFilesChange = (arrayAccepted) => {
        setFormState({
            ...formState,
            acceptedFiles: arrayAccepted
        });
    };

    const onDropZoneRejectionsFilesChange = (arrayRejections) => {
        setFormState({
            ...formState,
            fileRejections: arrayRejections
        });
    };

    const onImagesChange = (imagesArray) => {
        setFormState(prev => ({
            ...prev,
            images: imagesArray
        }));
    };

    // ---- Ajuste: reset completo (datos + imágenes) ----
    const onResetForm = () => {
        setFormState({
            ...initialForm,
            acceptedFiles: [],
            fileRejections: [],
            images: []
        });
        setElementResetFlag(prevFlag => !prevFlag);
    };

    return {
        ...formState,
        formState,
        elementResetFlag,
        setFormState,
        onInputChange,
        onInputChangeForNumber,
        onSelectSearchChange,
        onResetForm,
        onDropZoneAcceptedFilesChange,
        onDropZoneRejectionsFilesChange,
        onImagesChange
    };
};